module.exports = __webpack_public_path__ + "static/media/sidebar-6.5322ba22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-6.jpg
// module id = 934
// module chunks = 0